import React, { useEffect } from "react";
import { DataLayerEvent, getValuesInLocalStorange } from "../services/lsq";
import { pageViewEvent } from '../services/adobeDataLayer';

function ThankYouRejected() {
  useEffect(() => {
    let pushToDataLayer = async () => {
      const resp = await getValuesInLocalStorange("userData");
      DataLayerEvent(resp?.email, resp?.mobile, "custom_event", "lap_campaign", "thakyou_page_viwed", "NA", false);
    }
    pushToDataLayer();
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you not eligible");
  }, [])
  return (
    <>
      <article className="thankyou_sec">
        <div className="tick">
          <img
            src={process.env.PUBLIC_URL + "/dist/img/cross.png"}
            alt="tick"
            width={100}
            height={100}
            className="img-fluid"
          />
        </div>
        <div className="thankyou_txt">
          <p className="mb-5">
            Thank you for showing interest. We regret to inform you that you are not eligible.
          </p>
          <hr />
        </div>

      </article>

    </>
  );
}

export default ThankYouRejected;
